/**
 * Контент справки для страницы Sharing (Доступ).
 * Используется в панели справки HelpPanel.
 */
export default {
  pageKey: 'sharing',
  titleKey: 'help.pages.sharing.title',
  overviewKey: 'help.pages.sharing.overview',
  tourId: 'sharing-page',

  faq: [
    {
      id: 'what-is-sharing',
      questionKey: 'help.pages.sharing.faq.whatIsSharing.question',
      answerKey: 'help.pages.sharing.faq.whatIsSharing.answer',
    },
    {
      id: 'create-link',
      questionKey: 'help.pages.sharing.faq.createLink.question',
      answerKey: 'help.pages.sharing.faq.createLink.answer',
    },
    {
      id: 'expiration',
      questionKey: 'help.pages.sharing.faq.expiration.question',
      answerKey: 'help.pages.sharing.faq.expiration.answer',
    },
    {
      id: 'password',
      questionKey: 'help.pages.sharing.faq.password.question',
      answerKey: 'help.pages.sharing.faq.password.answer',
    },
    {
      id: 'permissions',
      questionKey: 'help.pages.sharing.faq.permissions.question',
      answerKey: 'help.pages.sharing.faq.permissions.answer',
    },
    {
      id: 'difference-subusers',
      questionKey: 'help.pages.sharing.faq.differenceSubusers.question',
      answerKey: 'help.pages.sharing.faq.differenceSubusers.answer',
    },
    {
      id: 'revoke',
      questionKey: 'help.pages.sharing.faq.revoke.question',
      answerKey: 'help.pages.sharing.faq.revoke.answer',
    },
    {
      id: 'access-log',
      questionKey: 'help.pages.sharing.faq.accessLog.question',
      answerKey: 'help.pages.sharing.faq.accessLog.answer',
    },
    {
      id: 'edit-link',
      questionKey: 'help.pages.sharing.faq.editLink.question',
      answerKey: 'help.pages.sharing.faq.editLink.answer',
    },
    {
      id: 'security',
      questionKey: 'help.pages.sharing.faq.security.question',
      answerKey: 'help.pages.sharing.faq.security.answer',
    },
  ],

  tooltips: {
    createButton: 'help.tooltips.sharing.createButton',
    statusFilter: 'help.tooltips.sharing.statusFilter',
    search: 'help.tooltips.sharing.search',
    flags: 'help.tooltips.sharing.flags',
    copyLink: 'help.tooltips.sharing.copyLink',
    accessLog: 'help.tooltips.sharing.accessLog',
    revoke: 'help.tooltips.sharing.revoke',
  },

  relatedTours: ['subusers-page', 'devices-page'],
}
